document.addEventListener('DOMContentLoaded', () => {
  const messages = document.querySelectorAll('#announcementBar .announcement-bar-container');
  let index = 0;
  let autoAdvanceInterval = null;

  const hasExpandedPanel = () =>
    document.querySelector('.panel-content.active-expanded') !== null;

  const getNextPanelContent = (el) => {
    let next = el.nextElementSibling;
    while (next && !next.classList.contains('panel-content')) {
      next = next.nextElementSibling;
    }
    return next;
  };

  function clearActivePanels() {
    document.querySelectorAll('.panel-content.active-expanded').forEach(panel =>
      panel.classList.remove('active-expanded')
    );
    document.querySelectorAll('.panel-header.active-toggle').forEach(header =>
      header.classList.remove('active-toggle')
    );
  }

  function toggleAnnouncementPanel(headerElement) {
    headerElement.classList.toggle('active-toggle');
    const panelContent = getNextPanelContent(headerElement);

    if (panelContent) {
      panelContent.classList.toggle('active-expanded');
      pauseAutoAdvance();
    }
  }

  /** Message Slider **/
  function showMessage(newIndex) {
    clearActivePanels();
    messages[index].classList.remove('active');
    index = (newIndex + messages.length) % messages.length;
    messages[index].classList.add('active');
  }

  function showNextMessage() {
    if (!hasExpandedPanel()) {
      showMessage(index + 1);
    }
  }

  function showPrevMessage() {
    if (!hasExpandedPanel()) {
      showMessage(index - 1);
    }
  }

  window.showNextMessage = showNextMessage;
  window.showPrevMessage = showPrevMessage;
  window.toggleAnnouncementPanel = toggleAnnouncementPanel;

  function startAutoAdvance() {
     if (autoAdvanceInterval) {
      clearInterval(autoAdvanceInterval);
    }
    autoAdvanceInterval = setInterval(showNextMessage, 6000);
  } 

  function pauseAutoAdvance() {
    clearInterval(autoAdvanceInterval);
  }

  function resumeAutoAdvance() {
    startAutoAdvance();
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.panel-header') && !event.target.closest('.panel-content')) {
      clearActivePanels();
    }
  });

  window.addEventListener('scroll', clearActivePanels);

  document.querySelectorAll('.panel-content, .announcement-bar-item-slide').forEach(el => {
    el.addEventListener('mouseenter', pauseAutoAdvance);
    el.addEventListener('mouseleave', resumeAutoAdvance);
    el.addEventListener('touchstart', pauseAutoAdvance, { passive: true });
    el.addEventListener('touchend', resumeAutoAdvance, { passive: true });
    el.addEventListener('touchcancel', resumeAutoAdvance, { passive: true });
  });

  startAutoAdvance();
});
